import { render, staticRenderFns } from "./qrcode-icon.vue?vue&type=template&id=8b96ed00"
import script from "./qrcode-icon.vue?vue&type=script&lang=js"
export * from "./qrcode-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports